// ** React Imports
import React, { FC, useEffect } from 'react'

// ** MUI Imports
import { Checkbox, Typography, Tooltip } from '@mui/material'
import { validateColor } from 'src/lib/utils/helpers'

interface FloCheckboxProps {
  value: boolean
  type?: 'SWITCH' | 'CHECKBOX'
  name?: string
  label?: React.ReactNode | undefined
  setValue?: any
  isDisabled?: boolean
  isIndeterminate?: boolean
  color?: string
  tooltipTitle?: string
}

const FloCheckbox: FC<FloCheckboxProps> = ({
  value,
  type = 'CHECKBOX',
  name,
  label,
  setValue,
  isDisabled,
  isIndeterminate,
  color,
  tooltipTitle 
}) => {
  return (
    <Tooltip title={tooltipTitle}>
      <div className='flex items-center -ml-1'>
        {type === 'CHECKBOX' && (
          <>
            <Checkbox
              name={name}
              sx={{
                padding: '0px 6px 0px 0px',
                transform: 'scale(0.85)',
                color: color && validateColor(color) ? `${color} !important` : '#4D4D4D !important',
                opacity: isDisabled ? 0.5 : 1
              }}
              checked={value}
              indeterminate={isIndeterminate}
              disabled={Boolean(isDisabled)}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                if (typeof setValue === 'undefined') return
                setValue((event.target as HTMLInputElement).checked)
              }}
            />
            <Typography variant='body1' sx={{ fontSize: '14px', color: isDisabled ? '#949494' : '#4d4d4d' }}>
              {label}
            </Typography>
          </>
        )}
        {type === 'SWITCH' && (
          <>
            <label className='flex cursor-pointer select-none items-center'>
              <div className='relative'>
                <input
                  type='checkbox'
                  disabled={isDisabled}
                  checked={value}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    if (typeof setValue === 'undefined') return
                    setValue((event.target as HTMLInputElement).checked)
                  }}
                  className='sr-only'
                />
                <div
                  className={`box block h-8 w-14 rounded-full ${
                    value ? 'bg-primary-dark' : `${isDisabled ? 'bg-[#3A35412E]' : 'bg-gray-light'}`
                  } ${isDisabled ? 'opacity-50' : 'opacity-100'}`}
                ></div>
                <div
                  className={`absolute left-1 top-1 flex h-6 w-6 items-center justify-center rounded-full ${
                    isDisabled ? 'bg-[#3A35414D]' : ' bg-white '
                  }  transition ${value ? 'translate-x-full' : ''}`}
                ></div>
              </div>
            </label>
          </>
        )}
      </div>
    </Tooltip>
  )
}

export default FloCheckbox